<script lang="ts">
  import Button from '$lib/components/ui/button/button.svelte';
  import * as Dialog from '$lib/components/ui/dialog';

  let {
    open = $bindable(true),
    onLogin,
  }: {
    open?: boolean;
    onLogin?: () => void;
  } = $props();

  $effect(() => {
    if (!open) {
      history.replaceState({}, '', window.location.pathname);
    }
  });
</script>

<Dialog.Root bind:open>
  <Dialog.Content class="sm:max-w-[420px] border-none shadow-lg">
    <Dialog.Header class="!p-4 !pb-0 !mt-4">
      <Dialog.Title class="text-xl font-semibold">Admin Access Required</Dialog.Title>
    </Dialog.Header>

    <div class="flex !flex-col gap-4 w-full justify-start items-start !p-5 !pt-2">
      <p class="text-sm text-muted-foreground">
        This design can only be viewed by an admin. Please log in with your admin account to continue.
      </p>

      <Button
        onclick={() => {
          open = false;
          onLogin?.();
        }}
        class="h-9 !px-4 !py-6 border-none !shadow-none !text-sm font-normal hover:brightness-110 transition text-white w-full !bg-[#004976] dark:!bg-[var(--theme-link)]"
      >
        Log In
      </Button>
    </div>
  </Dialog.Content>
</Dialog.Root>
